<template>
  <div class="snippet" :class="{ 'snippet-collapsed': isCollapsed }">
    <slot name="header" />
    <div
      @click="isCollapsed = !isCollapsed"
      :class="{
        'border-moon-grey-transparent border-b border-solid': isCollapsed
      }"
      v-test="{ id: 'snippet-title' }"
      class="flex flex-col flex-no-grow flex-no-shrink px-32 bg-east-bay cursor-pointer"
    >
      <div
        v-test="{ id: 'snippet-title-inner' }"
        class="flex justify-between py-16"
        :class="{ 'opacity-60': isCollapsed }"
      >
        <span class="flex items-center text-white font-semibold">
          <div class="flex items-center mr-24">
            <chevron-right
              v-test="{
                id: isCollapsed
                  ? 'snippet-chevron-closed'
                  : 'snippet-chevron-open'
              }"
              class="w-16 h-16 transition-fast-in-out fill-current"
              :class="{ 'rotate-90': !isCollapsed }"
            />
          </div>
          {{ title }}
        </span>
        <snippet-copy-button
          v-test="{ id: 'snippet-copy-button' }"
          v-if="copyButton && !isCollapsed"
          :content="getCode(getDataset.code)"
          class="p-8 -m-8"
        />
      </div>
      <ul
        v-show="!isCollapsed"
        v-if="showTabs(content)"
        v-test="{ id: 'snippet-tabs' }"
        class="list-reset"
      >
        <li
          @click.stop="$emit('update:tab', index)"
          :key="dataset.id"
          v-for="(dataset, index) in content"
          :class="[
            tab === index
              ? 'bg-martinique text-martinique z-10'
              : 'bg-scampi text-scampi'
          ]"
          v-test="{ id: 'snippet-tab' }"
          class="label inline-block mr-8"
        >
          <span class="text-white">{{ dataset.label }}</span>
        </li>
      </ul>
    </div>
    <template v-if="scrollable">
      <VuePerfectScrollbar
        v-show="!isCollapsed"
        v-test="{ id: 'snippet-content' }"
        class="flex-grow"
      >
        <div class="py-24 px-40">
          <slot>
            <highlighted-code
              :language="getDataset.language"
              :code="getDataset.code"
            />
          </slot>
        </div>
      </VuePerfectScrollbar>
    </template>
    <template v-else>
      <div
        v-show="!isCollapsed"
        v-test="{ id: 'snippet-content' }"
        class="flex flex-col min-h-0"
      >
        <slot>
          <highlighted-code
            :language="getDataset.language"
            :code="getDataset.code"
          />
        </slot>
      </div>
    </template>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import { isDefined } from '@/scripts/Utils'
import injectCredentials from '@/scripts/InjectCredentials'

import SnippetCopyButton from '@/components/SnippetCopyButton'
import HighlightedCode from '@/components/HighlightedCode'

import ChevronRight from '@/assets/images/chevron-right.svg'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: Array,
      default() {
        return []
      }
    },
    copyButton: {
      type: Boolean,
      default: true
    },
    scrollable: {
      type: Boolean,
      default: true
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    tab: {
      type: Number,
      default: 0
    }
  },
  components: {
    VuePerfectScrollbar,
    SnippetCopyButton,
    ChevronRight,
    HighlightedCode
  },
  data() {
    return {
      isCollapsed: this.collapsed
    }
  },
  watch: {
    collapsed(collapsed) {
      this.isCollapsed = collapsed
    }
  },
  computed: {
    getDataset() {
      const dataset = this.content[this.tab]
      const firstDataset = this.content[0]
      return (
        dataset ||
        firstDataset || {
          language: '',
          code: ''
        }
      )
    }
  },
  methods: {
    showTabs(content) {
      let show = false
      content.forEach(dataset => (show = isDefined(dataset.label)))
      return show
    },
    getCode(code) {
      return injectCredentials(code, this.$store.state, false)
    }
  }
}
</script>

<style lang="scss">
.snippet .ps__scrollbar {
  &-x,
  &-y {
    background: #5d6494 !important;
  }
}
</style>
